/**
 * A single-letter shortcut (Linear's `C`, shadcn's `D`) must stay out of the way
 * of typing: never with a modifier (Cmd+C is copy), never from a text field, and
 * never while another dialog, menu or picker has the keyboard.
 */
const KEYBOARD_OWNERS = '[role="dialog"], [role="alertdialog"], [role="menu"], [role="listbox"], [cmdk-root]';

/** A text field or rich editor, where a key press is typing, not a shortcut. */
export function isTypingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false;
  if (target instanceof HTMLElement && target.isContentEditable) return true;
  return target.closest("input, textarea, select") !== null;
}

export function isBareKeyShortcut(event: KeyboardEvent, key: string): boolean {
  // `?.`: a plain `Event("keydown")` has no `key` (BRE-9884).
  if (event.key?.toLowerCase() !== key.toLowerCase()) return false;
  // Shift is part of a symbol key ("?"), a modifier on a letter.
  const isLetter = key.toLowerCase() !== key.toUpperCase();
  if (event.metaKey || event.ctrlKey || event.altKey || (isLetter && event.shiftKey)) return false;
  if (event.repeat || event.isComposing || event.defaultPrevented) return false;
  const target = event.target;
  if (!(target instanceof Element)) return true;
  if (isTypingTarget(target)) return false;
  return !target.closest(KEYBOARD_OWNERS);
}
